import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'element']
  static values = {
    on: String,
    off: String,
    attribute: String
  }

  connect() {
    this.update()
  }

  update() {
    const checked = this.inputTarget.checked
    const val = checked ? this.onValue : this.offValue
    this.elementTargets.forEach((el) => el.setAttribute(this.attributeValue, val))
  }
}
